export const APP_NAME = "MarkFeed";
export const DEFAULT_TIMEZONE = "Asia/Kolkata";
export const DEFAULT_LOCALE = "en-IN";
export const SUPPORTED_LOCALES = ["en-IN", "hi-IN", "hinglish"] as const;

export const ROLES = ["owner", "admin", "member", "client"] as const;
export type Role = (typeof ROLES)[number];

/** Higher number = more privilege. Clients sit below members. */
export const ROLE_RANK: Record<Role, number> = { client: 0, member: 1, admin: 2, owner: 3 };

export const TASK_STATUSES = ["open", "in_progress", "awaiting_review", "resolved", "closed"] as const;
export type TaskStatus = (typeof TASK_STATUSES)[number];
export const TASK_STATUS_LABEL: Record<TaskStatus, string> = {
  open: "Open",
  in_progress: "In Progress",
  awaiting_review: "Awaiting Review",
  resolved: "Resolved",
  closed: "Closed",
};
/** Kanban columns (closed is kept off the board). */
export const KANBAN_COLUMNS: TaskStatus[] = ["open", "in_progress", "awaiting_review", "resolved"];

export const PRIORITIES = ["low", "medium", "high", "critical"] as const;
export type Priority = (typeof PRIORITIES)[number];
export const PRIORITY_LABEL: Record<Priority, string> = {
  low: "Low",
  medium: "Medium",
  high: "High",
  critical: "Critical",
};

export const PROJECT_STATUSES = ["planning", "in_progress", "in_review", "on_hold", "completed"] as const;
export type ProjectStatus = (typeof PROJECT_STATUSES)[number];
export const PROJECT_STATUS_LABEL: Record<ProjectStatus, string> = {
  planning: "Planning",
  in_progress: "In Progress",
  in_review: "In Review",
  on_hold: "On Hold",
  completed: "Completed",
};

export const PLATFORMS = ["wordpress", "shopify", "html", "react", "nextjs", "other"] as const;
export type Platform = (typeof PLATFORMS)[number];
export const PLATFORM_LABEL: Record<Platform, string> = {
  wordpress: "WordPress",
  shopify: "Shopify",
  html: "Custom HTML",
  react: "React",
  nextjs: "Next.js",
  other: "Other",
};

export const PERSONAS = ["freelancer", "agency", "startup", "product_team", "designer", "developer", "other"] as const;
export type Persona = (typeof PERSONAS)[number];

export const APPROVAL_DECISIONS = ["approved", "changes_requested"] as const;
export type ApprovalDecision = (typeof APPROVAL_DECISIONS)[number];

export const DEVICE_TYPES = ["desktop", "tablet", "mobile"] as const;
export type DeviceType = (typeof DEVICE_TYPES)[number];

export const NOTIFICATION_EVENTS = [
  "feedback.created",
  "feedback.assigned",
  "feedback.replied",
  "feedback.resolved",
  "feedback.reopened",
  "approval.changes_requested",
  "approval.approved",
  "project.due_soon",
  "billing.payment_received",
  "billing.payment_failed",
  "billing.renewal_due",
] as const;
export type NotificationEvent = (typeof NOTIFICATION_EVENTS)[number];

export const NOTIFICATION_CHANNELS = ["in_app", "email", "whatsapp"] as const;
export type NotificationChannel = (typeof NOTIFICATION_CHANNELS)[number];

export const ATTACHMENT_MIME_TYPES = [
  "image/png",
  "image/jpeg",
  "image/webp",
  "image/gif",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/plain",
] as const;

/** Indian mobile: +91 followed by 10 digits starting 6-9. */
export const INDIAN_PHONE_REGEX = /^\+91[6-9]\d{9}$/;

/**
 * Feature switches. Mockups (design uploads with pinned comments) is fully built but not launched yet:
 * set `mockups: true` to turn on the API routes, the /app/mockups pages and the /m/:token client links.
 */
export const FEATURES = {
  mockups: false,
} as const;
